import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { BidEntityByContract } from "interfaces";
import { reaction } from "mobx";

export class ContractBidsList extends ListStoreConstructor<BidEntityByContract> {
  id: string = "";

  setId(id: string) {
    this.id = id;
  }

  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        const paramsWithSort = {
          ...params,
          sort: ["statusDate,desc"],
        };
        return services
          .getContractBidList({ id: this.stores.contractCard.card.id }, paramsWithSort)
          .then((response) => ({
            content: response.content || [],
            size: response.size || 0,
            totalPages: response.totalPages || 0,
            totalElements: response.totalElements || 0,
          }));
      },
      {
        pollingInterval: 10000,
      }
    );
    reaction(
      () => this.stores.contractCard.card.id,
      () => {
        if (this.stores.contractCard.card.id) {
          return this.fetch();
        }
      }
    );
  }
}
